import StatusSymbol from './StatusSymbol'

export default StatusSymbol
